export default class DataSource {
  constructor(server, method, config = {}){
    this.draw = 0;
    this.result = [];
    this.dummy = [];
    this.filter = config.filter || {};
    this.limit = config.limit || 20;
    this.order = config.order || null;
    this.offset = config.offset || 0;
    this.totalResults = 0;
    this.filteredResults = 0;
    this.working = false;
    this.server = server;
    this.method = method;
  }

  load(){
    const draw = ++this.draw;
    this.working = true;
    return this.server(this.method, {
      filter: this.filter,
      order: this.order,
      limit: this.limit,
      offset: this.offset
    }).then(data => {
      if(draw == this.draw){
        this.result = data.result;
        this.totalResults = data.totalResults;
        this.filteredResults = data.filteredResults;
        this.working = false;
        this.dummy = [];
        for(var i=this.result.length; i < this.limit; i++){
          this.dummy.push(i);
        }
      }
      return this.result;
    });
  }

  wait(){
    return this.load().then(() => this);
  }

}


// WEBPACK FOOTER //
// ./src/DataSource/DataSource.js